<template>
  <div class="absolute top-0 flex justify-evenly w-full bg-gray-900 text-white">
    <button @click="email">EMAIL (måste klicka innan AUTH)</button>
    <button @click="auth">AUTH</button>
    <button @click="claim">CLAIM</button>
    <button @click="cheat">FUSKA</button>
  </div>
</template>

<script>
import http from '@/store/shared/http';

export default {
  name: 'Temporary',
  data: () => ({
    devOnly: {
      testEmail: 'test'
    }
  }),
  methods: {
    auth() {
      return this.$store.dispatch('AUTHENTICATE', this.devOnly.testEmail);
    },
    async cheat() {
      try {
        this.$router.push({
          path: '/my-claim',
          query: { id: this.devOnly.testEmail }
        });
      } catch (e) {
        console.log(e);
      }
    },
    async claim() {
      await this.$store.dispatch('CREATE_CLAIM', 'Illness');
      return this.$store.dispatch('GET_CLAIM', this.$store.state.claim.id);
    },
    email() {
      return http
        .post('/emails', {
          birthDate: '2021-12-12',
          efSalesRefCode: 'LES123456789',
          email: 'gustaf.oldertz@ef.com',
          firstName: 'Nisse'
        })
        .then((res) => {
          this.devOnly.testEmail = res.data.emailLinkId;
        })
        .catch((e) => this.$store.commit('SET_ERROR', e));
    }
  }
};
</script>
